import {get} from 'lodash'
import axios from 'axios'

const baseURL = '/api/user/'
export default class SocialNetwork {
	constructor (init) {
		this.user_id = get(init, 'user_id') ? init.user_id : null
		this.id = get(init, 'id') ? init.id : null
		this.leader_id = get(init, 'leader_id') ? init.leader_id : null
		this.social_name = get(init, 'social_name') ? init.social_name : ''
		this.social_link = get(init, 'social_link') ? init.social_link : ''
		this.hasDuplicate = false
	}

	delete () {
		const formData = new FormData()
		formData.append('social[][detach]', this.leader_id)
		return axios.post(`${baseURL}${this.user_id}`, formData)
	}

	static networkList = [
		{
			id: 20,
			social_name: 'Инстаграм'
		},
		{
			id: 14,
			social_name: 'Facebook'
		},
		{
			id: 15,
			social_name: 'Вконтакте'
		},
		{
			id: 17,
			social_name: 'LinkedIn'
		}
	]
}



// WEBPACK FOOTER //
// ./src/assets/js/User/SocialNetwork.js